import React from "react";
import Icon from "../../../components/ui/Icon";
import Photo from "../../../components/ui/Photo";
import { ISaleRelationId } from "../../../classes/interfaces";
import { Card, Info, Name, InfoRow } from "./StoreInfoCard.styles";

interface StoreInfoCardProps {
  store: ISaleRelationId;
}

export default function StoreInfoCard({ store }: StoreInfoCardProps) {
  return (
    <Card>
      <Photo
        src={store.imageUrl || undefined}
        label={store?.name || "loja"}
        radius={999}
        style={{ width: 62, height: 62, flexShrink: 0 }}
      />
      <Info>
        <Name>{store?.name}</Name>
        <InfoRow>
          <Icon name="pin" size={14} />
          {store?.address +
            ", " +
            store?.number +
            " - " +
            store?.district +
            " - " +
            store?.city?.name +
            "/" +
            store?.city?.state}
        </InfoRow>
        <InfoRow>
          <Icon name="phone" size={14} />
          {store?.phone}
        </InfoRow>
      </Info>
    </Card>
  );
}
